import useSWR from 'swr';

import { GET_INDICACIONES } from '../axios/constants';
import { getIndicaciones } from '../axios/getIndicaciones';

export const useGetIndicaciones = (id: string) => {
  const { data, isValidating, error, mutate } = useSWR(
    id ? [GET_INDICACIONES, id] : null,
    (url) => getIndicaciones(url, id)
  );

  return { data, isValidating, error, mutate };
};
